// Public "Try 3 real questions" API (ROO-142) — no-signup sample flow.
// Mirrors the axios pattern used by api/placement.ts, but deliberately sends
// NO auth headers: this flow must work for a completely anonymous visitor.

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

/** Unwrap a possible {success,data} envelope defensively — the exact shape
 * of the public endpoints is still being finalised server-side in parallel. */
function unwrap<T>(payload: any): T {
  if (payload && typeof payload === 'object' && 'data' in payload) {
    return payload.data as T;
  }
  return payload as T;
}

export interface TryAnswerOption {
  text: string;
  value: string;
  img?: string | null;
}

export interface TryQuestion {
  id: string;
  type: string;
  title: string;
  subject: string;
  content: Record<string, unknown>;
  answers: TryAnswerOption[];
}

export interface TrySession {
  questions: TryQuestion[];
  tryToken: string;
}

/** Start a 3-question public sample for a subject ('maths' | 'english'). */
export async function startTry(subject: string): Promise<TrySession> {
  const res = await axios.get(
    `${API_BASE_URL}/api/public/try/${subject}`,
    { headers: { 'Content-Type': 'application/json' } }
  );
  return unwrap<TrySession>(res.data);
}

export interface TrySubmitAnswer {
  questionId: string;
  answer: string | string[];
}

export interface TryGradeResultItem {
  questionId: string;
  correct: boolean;
  correctAnswer: string | string[];
  explanation?: string | null;
}

export interface TryGradeResult {
  results: TryGradeResultItem[];
  score: number;
  total: number;
}

/** Grade the anonymous visitor's answers server-side (never graded client-side). */
export async function gradeTry(
  tryToken: string,
  answers: TrySubmitAnswer[]
): Promise<TryGradeResult> {
  const res = await axios.post(
    `${API_BASE_URL}/api/public/try/grade`,
    { tryToken, answers },
    { headers: { 'Content-Type': 'application/json' } }
  );
  return unwrap<TryGradeResult>(res.data);
}
